import { useMemo } from 'react'
import { uniq } from 'lodash'

import {
  HEARD_PROVIDER_NAME,
  IDocumentsStepContext,
  Document,
} from '../../end-of-year-review/types'
import { filterNulls } from '@/utils/typeHelpers'

const shouldIncludeDoc = (doc: Document, isFollowup: boolean) => {
  const isHeard = doc.provider === HEARD_PROVIDER_NAME
  const needsReupload = doc.requestReUpload === true
  const needsUpload = !doc.documentId

  // In follow-up mode, exclude Heard unless it needs re-upload.
  if (isFollowup) return needsReupload || (!isHeard && needsUpload)

  // In normal flow, show non-Heard providers (and non-uploaded items) as usual.
  return !isHeard
}

export function useFilteredPayrollProviders(
  stepContext: IDocumentsStepContext | undefined,
  isFollowup = false
) {
  return useMemo(() => {
    const docs = stepContext?.documents ?? []
    return filterNulls(
      uniq(
        docs
          .filter((doc) => shouldIncludeDoc(doc, isFollowup))
          .map((doc) => doc.provider)
      )
    )
  }, [stepContext?.documents, isFollowup])
}
